export const ACTIVE_TRUE: boolean = true;
export const ACTIVE_FALSE: boolean = false;

export const ACTIVE_TYPE_LIST: ActiveTypeItem[] = [
  {
    id: 1,
    name: ACTIVE_TRUE,
    title: 'Yes',
  },
  {
    id: 2,
    name: ACTIVE_FALSE,
    title: 'No',
  },
];
